import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Success } from '../../assets/icons/success.svg';
import { Button } from '..';
import { Modal } from '.';

const SuccessModal = ({ message, onModalClose, ...props }) => {
  return (
    <Modal header={{ name: 'Success!' }} Icon={Success} onModalClose={onModalClose} {...props}>
      <p className="modal__text">{message}</p>
      <Button isFull onClick={onModalClose}>
        Done
      </Button>
    </Modal>
  );
};

SuccessModal.propTypes = {
  message: PropTypes.string,
  onModalClose: PropTypes.func
};

export { SuccessModal };
